
import { required, minLength, email,/* , email, sameAs */ } from "vuelidate/lib/validators";
const fields  = () =>{return  [
	{
		name:'email',
		label:'Email Address',
		type:'email',
		values:'',
		readonly:false,
		layout:'col s12 l6',
		helperText:{
			d:'Required', s:'Valid', e: 'Valid email address required'
		},
		v: true,
		rule: {
			required,
			email
		},
	},
	{
		name:'contact',
		label:'Requesting Party Contact# (xxx xxx xxxx)',
		type:'text',
		values:'',
		readonly:false,
		layout:'col s12 l6',
		helperText:{
			d:'Required', s:'Valid', e: 'Enter a valid contact number inluding area code'
		},
		v: true,
		rule: {
			required,
			minLength: minLength(10),
		},
	},
	{
		label:'Name of Requesting Party',
		name:'requesting_party',
		type:'text_area',
		values:'',
		layout:'col s12',
		readonly:false,
		helperText:{
			d:'Required', s:'Valid', e: 'Field is required'
		},
		v: true,
		rule: {
			required
		},
	},
	{
		label:'Name of Transcriptionist',
		name:'transcriptionist',
		type:'select',
		readonly:false,
		dataType:'Object',
		layout:'col s6',
		helperText:{
			d:'Required', s:'Valid', e: 'Must select an option'
		},
		v: true,
		rule: {
			required,
			minLength: minLength(2)
		},
		options:[
			{
				name: 'J&J Court Transcribers',
				prop: 'jj_court_transcribers',
				email: 'jjcourt@jjcourt.com',
				id: 11,
			},
			{
				name: 'Jean Morille',
				prop: 'jean_morille',
				email: 'transcriptsolutionsslu@gmail.com',
				id: 12,
			},
			{
				name: 'Jacqueline Ladoo',
				prop: 'jacqueline_ladoo',
				email: 'jladoo@hotmail.com',
				id: 13,
			},
			{
				name: 'Jean-Marie A. Browne',
				prop: 'jeanmarie_a_browne',
				email: 'jean4reporting@gmail.com',
				id: 14,
			},
			{
				name: 'Verna Monerville',
				prop: 'verna_monerville',
				email: 'verna38monerville@gmail.com',
				id: 15,
			},
			{
				name: 'Yvonne Ratoo',
				prop: 'yvonne_ratoo',
				email: 'vonnie123@hotmail.com',
				id: 16,
			},
		],
		values: '',
	},
	{
		label:'Proceeding (trial, appeal etc.)',
		name:'proceeding_trial',
		type:'text',
		values: '',
		readonly:false,
		layout:'col s6',
	},
	{
		name:'case_name',
		label:'Case Name',
		type:'text',
		values:'',
		readonly:false,
		layout:'col s12',
		helperText:{
			d:'Required', s:'Valid', e: 'Minimum of 12 characters '
		},
		v: true,
		rule: {
			required,
			minLength: minLength(6)
		},
	},
	{
		name:'judges',
		label:'Judges',
		type:'content_array',
		single_name:'Judge',
		entryFieldType:'textarea',
		dataType:'schema',
		match: 'judge',
		values:new Object,
		layout:'col s12 layout-fix '
	},
	{
		name:'case_number',
		label:'Case Number',
		type:'text',
		values:'',
		readonly:false,
		v: true,
		rule: {
			required,
			minLength: minLength(6)
		},

		helperText:{
			d:'Must include case number', s:'Valid', e: 'Valid case number required'
		},
		layout:'col s12'
	},
	{
		label:'Location Where Matter was Heard',
		name:'heard',
		type:'text_area',
		values:'',
		layout:'col s12',
		v: true,
		rule: {
			required,
			minLength: minLength(4)
		},
		helperText:{
			d:'Required to submit request', s:'Valid', e: 'Must be completed to submit'
		},
		readonly:false,
	},
	/* 	{
			name:'name',
			label:'Title',
			type:'text',
			values:'',
			readonly:false,
			layout:'col s12',
			helperText:{
				d:'Required', s:'Valid', e: 'Minimum of 12 charaters '
			},
			v: true,
			rule: {
        required,
        minLength: minLength(12)
      },
		},
	 */
		{
			label:'Appearances',
			name:'appearances',
			type:'text_area',
			values:'',
			layout:'col s12',
			readonly:false,
			v: true,
			rule: {
				required,
			},
			helperText:{
				d:'Required to submit request', s:'Valid', e: 'Must be completed to submit'
			},
		},
		{
			label:'Names of Legal Practitioners',
			name:'practitioners',
			type:'text_area',
			values:'',
			layout:'col s12',
			readonly:false,
		},
		{
			name:'hearing_dates',
			label:'Date of Trial/Hearing',
			type:'content_array',
			single_name:'Date',
			entryFieldType:'date',
			dataType:'schema',
			dateFieldProps:{
				maxDate: new Date()
			},
			match: 'hearing_dates',
			values:new Array,
			layout:'col s12 layout-fix ',
			v: true,
			rule: {
				required,
			},
			helperText:{
				d:'Atleast one date is required', s:'Valid', e: 'Atleast one date is required'
			},
		},
		{
			label:'Turn around time in days',
			name:'turn_around_time',
			type:'number',
			values: 1,
			min:1,
			max:99,
			readonly:false,
			v: true,
			rule: {
				required,
			},
			helperText:{
				d:'Turn around time required', s:'Valid', e: 'Must have a valid number'
			},
			layout:'col s6',
		},
		{
			label:'Comments',
			name:'comments',
			type:'text_area',
			values:'',
			
			layout:'col s12',
			readonly:false,
		},
		//end of record
]
}
const generate = () =>{
	return fields.call()
}

const populate = (data) => {
	fields.forEach(item => {
		let key = item.name
		let v = data[key]
		
		if (item.dataType === 'Object'){
			v = item.options.find(a => a.prop === v)
		/* 	console.log(data) */
		}
		if(data[key]) {
			item.value = v
	
		}
	})
	return fields
}

const populateX = (data) => {

	let y = fields().map(item => {
			let x = {...item}
			x.values =  data[item.name]
			return x
		})
		y.unshift(
			{
				label:'Status',
				name:'status',
				type:'select',
				dataType:'Object',
				readonly:false,
				layout:'col s12 l6',
				values: {},
				options:[
					{
						name: 'Not Started',
						prop: 'not-started',
						id: 22,
					},
					{
						name: 'Pending',
						prop: 'pending',
						id: 23,
					},
					{
						name: 'Complete',
						prop: 'complete',
						id: 24,
					},
					{
						name: 'On-hold',
						prop: 'on-hold',
						id: 25,
					},
					{
						name: 'Unresloved',
						prop: 'unresloved',
						id: 26,
					},
				]
		})
		return y
	}
	
export default {
	fields, generate, populate,populateX
}